module.exports = __webpack_public_path__ + "img/recharge.2d94ad86.png";